'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _shops = require('redux/modules/shops');

var _lib = require('helpers/lib');

var _ = require('./');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxLengthComment = 185;

var ReviewMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, { submitReply: _shops.submitReply }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ReviewMobile, _Component);

  function ReviewMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReviewMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReviewMobile.__proto__ || (0, _getPrototypeOf2.default)(ReviewMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showReply: false,
      showFullComment: false,
      reply: '',
      showModalMedia: false,
      currentIndexImage: 0
    }, _this.handleShowFullComment = function () {
      _this.setState({ showFullComment: true });
    }, _this.handleChangeReply = function (event) {
      _this.setState({ reply: event.target.value });
    }, _this.submitReply = function () {
      var replyMessage = _this.state.reply;
      var reviewId = _this.props.review._id;
      var user = _this.props.user;
      if (!user) {
        alert('Vui lòng đăng nhập để có thể trả lời bình luận này.');
        return;
      }
      _this.props.submitReply(replyMessage, reviewId, user._id);
      _this.setState({ reply: '' });
    }, _this.handlePressReply = function (event) {
      if (event.keyCode === 13) {
        _this.submitReply();
      }
    }, _this.handleCloseModalMedia = function () {
      _this.setState({
        showModalMedia: false
      });
    }, _this.handleOpenModalMedia = function (index) {
      _this.setState({
        currentIndexImage: index,
        showModalMedia: true
      });
    }, _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
      event.target.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReviewMobile, [{
    key: 'handleShowReply',
    value: function handleShowReply() {
      var currentShowStatus = this.state.showReply;
      this.setState({ showReply: !currentShowStatus });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./ReviewMobile.scss');
      var _state = this.state,
          showReply = _state.showReply,
          showFullComment = _state.showFullComment,
          reply = _state.reply,
          showModalMedia = _state.showModalMedia,
          currentIndexImage = _state.currentIndexImage;
      var _props = this.props,
          review = _props.review,
          user = _props.user,
          shop = _props.shop;

      var reviewComment = review.comment;
      var showShowMore = false;
      if (!showFullComment && review.comment.length >= maxLengthComment) {
        reviewComment = reviewComment.slice(0, maxLengthComment) + '...';
        showShowMore = true;
      }
      var userReview = review.user;
      var avt = (0, _lib.getAvatarReview)(userReview);
      var stylePoint = {
        backgroundColor: (0, _lib.getColorRatingCode)(review.rating)
      };
      var items = [];
      review.assets.map(function (med, key) {
        items.push({
          thumbnail: (0, _lib.getUrlImage)(med),
          original: (0, _lib.getUrlImage)(med),
          asset: med,
          date: med.date,
          key: key,
          length: review.assets.length,
          styles: styles
          // renderItem: this.renderThumbnail
        });
      });
      return _react2.default.createElement(
        'div',
        { className: styles.comment, style: { width: '100%' } },
        _react2.default.createElement(
          'div',
          { className: styles.commentContainer },
          _react2.default.createElement(
            'div',
            { className: styles.avatarGroup },
            _react2.default.createElement(
              'div',
              { className: styles.avatarComment },
              _react2.default.createElement('img', { src: avt, alr: 'user avatar', onError: this.onErrorImage })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.commentBox },
            _react2.default.createElement(
              'div',
              { className: styles.boxHeader },
              _react2.default.createElement(
                'div',
                { className: styles.row },
                _react2.default.createElement(
                  'div',
                  { className: styles.commentName },
                  review.user && review.user.profile ? review.user.profile.name : 'Vô danh'
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.point, style: stylePoint },
                  review.rating.toString().length === 1 || review.rating === 10 ? review.rating.toString() + '.0' : review.rating
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.commentTime },
                  review.created ? (0, _lib.renderTime)(review.created) : (0, _lib.renderTime)(review.createdAt)
                )
              ),
              _react2.default.createElement('div', { className: styles.row }),
              _react2.default.createElement(
                'div',
                { className: styles.row },
                review.status === 'wait' && _react2.default.createElement(
                  'div',
                  { className: styles.wait },
                  ' \u0110\xE1nh gi\xE1 \u0111ang ch\u1EDD duy\u1EC7t'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.boxBody },
              _react2.default.createElement(
                'p',
                null,
                reviewComment,
                showShowMore && _react2.default.createElement(
                  'span',
                  {
                    className: styles.seeMore,
                    onClick: function onClick() {
                      return _this2.handleShowFullComment();
                    }
                  },
                  ' ',
                  'Xem th\xEAm'
                )
              ),
              review.assets && review.assets.length > 0 && _react2.default.createElement(
                'div',
                { className: styles.reviewImage },
                review.assets.map(function (asset, idx) {
                  if (idx < 2 || idx === 2 && review.assets.length === 3) {
                    return _react2.default.createElement(
                      'div',
                      {
                        className: styles.cmtImage,
                        key: idx,
                        onClick: function onClick() {
                          return _this2.handleOpenModalMedia();
                        }
                      },
                      _react2.default.createElement('img', {
                        src: (0, _lib.getUrlImage)(asset),
                        onError: _this2.onErrorImage
                      })
                    );
                  }
                  if (idx === 2 && review.assets.length > 3) {
                    return _react2.default.createElement(
                      'div',
                      {
                        className: styles.cmtImage,
                        key: idx,
                        onClick: function onClick() {
                          return _this2.handleOpenModalMedia();
                        }
                      },
                      _react2.default.createElement('div', { className: styles.fade }),
                      _react2.default.createElement('img', {
                        src: (0, _lib.getUrlImage)(asset),
                        onError: _this2.onErrorImage
                      }),
                      _react2.default.createElement(
                        'div',
                        {
                          className: styles.remainAssetCount,
                          style: { lineHeight: 78 + 'px' }
                        },
                        '+',
                        review.assets.length - 3
                      )
                    );
                  }
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.commentBottom },
              _react2.default.createElement('div', { className: styles.leftGroup })
            ),
            showReply && review.reply && review.reply.length > 0 && _react2.default.createElement(
              'div',
              { className: styles.commentReplyList },
              review.reply.map(function (rep, idx) {
                return _react2.default.createElement(
                  'div',
                  {
                    className: styles.commentReply,
                    key: 'reply_' + review._id + '_' + idx
                  },
                  _react2.default.createElement(
                    'div',
                    { className: styles.avatarGroupReply },
                    _react2.default.createElement(
                      'div',
                      { className: styles.avatarCommentReply },
                      _react2.default.createElement('img', {
                        src: (0, _lib.getAvatarReview)(rep.user),
                        onError: _this2.onErrorImage
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.contentCommentReply },
                    _react2.default.createElement(
                      'div',
                      { className: styles.commentTop },
                      _react2.default.createElement(
                        'div',
                        { className: styles.groupNameTime },
                        _react2.default.createElement(
                          'div',
                          { className: styles.commentName },
                          rep.user && rep.user.profile && rep.user.profile.name
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: styles.commentTime },
                          ' ',
                          (0, _lib.renderTime)(rep.createdAt)
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.commentMidReply },
                      _react2.default.createElement(
                        'p',
                        null,
                        rep.comment
                      )
                    )
                  )
                );
              }),
              user && (user._id === review.user._id || user._id === shop.owner_id) && _react2.default.createElement(
                'div',
                { className: styles.inputReply },
                _react2.default.createElement(_reactBootstrap.FormControl, {
                  type: 'text',
                  placeholder: 'Ph\u1EA3n h\u1ED3i c\u1EE7a b\u1EA1n',
                  className: styles.inputReplyText,
                  value: reply,
                  onChange: function onChange(event) {
                    return _this2.handleChangeReply(event);
                  },
                  onKeyDown: function onKeyDown(event) {
                    return _this2.handlePressReply(event);
                  }
                }),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    {
                      className: styles.buttonSave,
                      onClick: function onClick() {
                        return _this2.submitReply();
                      }
                    },
                    'G\u1EECI'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.avatarReplyInput },
                  _react2.default.createElement('img', {
                    src: (0, _lib.getAvatarReview)(user),
                    alr: 'user avatar',
                    onError: this.onErrorImage
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalMedia,
            hide: this.handleCloseModalMedia,
            className: 'modal-image-mobile-short'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'close-modal-button',
              onClick: this.handleCloseModalMedia
            },
            _react2.default.createElement('i', { className: 'fa fa-times' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.modalImage },
            items && items.length > 0 && _react2.default.createElement(_2.default, {
              showPlayButton: false,
              showBullets: false,
              showFullscreenButton: false,
              items: items,
              startIndex: currentIndexImage
            })
          )
        )
      );
    }
  }]);
  return ReviewMobile;
}(_react.Component), _class2.propTypes = {
  shop: _react.PropTypes.object,
  user: _react.PropTypes.object,
  review: _react.PropTypes.object,
  submitReply: _react.PropTypes.func,
  isProfile: _react.PropTypes.bool
}, _temp2)) || _class);
exports.default = ReviewMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/ReviewMobile.js
// module id = 714
// module chunks = 0